import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PercentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"percent"}/>
}
